import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";

declare var $: any;
declare var defaultGridEditSettings: any;

@Component({
  selector: "currency-groups",
  templateUrl: "./currency-groups.component.html",
  styleUrls: ["./currency-groups.component.css"],
})
export class CurrencyGroupsBranch implements OnInit {
  constructor(private route: ActivatedRoute, private titleService: Title) {}

  ngOnInit() {
    //Set the page title
    this.titleService.setTitle("WiseRisk | Currency Group Settings");

    /*<![CDATA[*/
    var mainNav = "setting-nav";
    var sideNav = "side-nav-setting-account-grp";

    $(document).ready(function () {
      var source = {
        datatype: "json",
        datafields: [
          {
            name: "accountGroupCode",
            type: "string",
          },
          {
            name: "displayName",
            type: "string",
          },
          {
            name: "organizationId",
            type: "string",
          },
          {
            name: "externalAccountGroupId",
            type: "string",
          },
          {
            name: "currencyGroupId",
            type: "string",
          },
        ],
        id: "accountGroupId",
        url: "/ajax/currency-groups",
        type: "GET",
        async: true,
      };
      var settings = defaultGridEditSettings("#jqxgrid", source);
      settings.columns = [
        {
          text: "Account Group Code",
          columntype: "textbox",
          datafield: "accountGroupCode",
          width: "25%",
        },
        {
          text: "Display Name",
          columntype: "textbox",
          datafield: "displayName",
          width: "40%",
        },
        {
          text: "Organization Id",
          datafield: "organizationID",
          hidden: true,
        },
        {
          text: "External Account Group Id",
          datafield: "externalAccountGroupId",
          hidden: true,
        },
        {
          text: "currencyGroupId",
          datafield: "currencyGroupId",
          hidden: true,
        },
      ];
      $("#jqxgrid").jqxGrid(settings);
    });
    /*]]>*/
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/settings/currency-groups/currency-groups.component.ts